import { SVGProps } from 'react'

export const Suitcase = ({
  size = 24,
  className,
  ...props
}: SVGProps<SVGSVGElement> & { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.2522 3H16.7522V7H22V21H2V7H7.25V6.5H7.2522V3ZM8.75 8.5V19.5H15.25V8.5H8.75ZM15.25 7H8.7522V4.5H15.2522V6.5H15.25V7ZM16.75 8.5V19.5H20.5V8.5H16.75ZM7.25 19.5V8.5H3.5V19.5H7.25Z"
      fill="currentColor"
    />
  </svg>
)
